import styled from 'styled-components';
import ThankYouPendingSvg from '../../assets/hotels/bkng-pending.svg';

const ThankYouPendingImg = styled(ThankYouPendingSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '29.6rem'};
  height: ${props => props.height || '19.9rem'};
  margin: ${props => props.margin};
`;

export default ThankYouPendingImg;
